var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home safe-area-inset-bottom" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/new_pages/seller1.jpg"),
          alt: "part 1"
        }
      }),
      _c("div", { attrs: { id: "willingForm1" } }),
      _c("img", {
        attrs: {
          src: require("@/assets/images/new_pages/seller2.jpg"),
          alt: "part 2"
        }
      }),
      _c("img", {
        attrs: {
          src: require("@/assets/images/new_pages/seller3.jpg"),
          alt: "part 3"
        }
      }),
      _c("img", {
        attrs: {
          src: require("@/assets/images/new_pages/seller4.jpg"),
          alt: "part 4"
        }
      }),
      _c("img", {
        attrs: {
          src: require("@/assets/images/new_pages/seller5.jpg"),
          alt: "part 5"
        }
      }),
      _c("div", { attrs: { id: "willingForm2" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }